import { z } from 'zod'
import { ExclusiveOfferLegacyType } from '~library/enums'
import { dateValueSchema } from '~library/models'
import { exclusiveOfferLegacyContentSchema } from './exclusive-offer-legacy-content'

/** 取得會員尊享明細資料 */
export const exclusiveOfferLegacyDetailDataSchema = z.object({
  /** 分類 */
  type: z.enum(ExclusiveOfferLegacyType),
  /** 航點 */
  airportCode: z.array(z.string()),
  /** 權重 */
  priority: z.string(),
  /** 時區 */
  timeZone: z.string(),
  /** 活動起始日期 */
  activityStartTime: dateValueSchema,
  /** 活動截止日期 */
  activityEndTime: dateValueSchema,
  /** 新商品 */
  newTag: z.boolean(),
  /** 限時 */
  flashSale: z.boolean(),
  /** 限量 */
  limitedEdition: z.boolean(),
  /** 優惠碼 */
  promoCode: z.string(),
  /** 內容 - 繁體中文 */
  contentZh: exclusiveOfferLegacyContentSchema,
  /** 內容 - 簡體中文 */
  contentCn: exclusiveOfferLegacyContentSchema,
  /** 內容 - 英文 */
  contentEn: exclusiveOfferLegacyContentSchema
})

export interface ExclusiveLegacyOfferDetailData extends z.infer<
  typeof exclusiveOfferLegacyDetailDataSchema
> {}
